import React, {useEffect } from 'react';
import '../../main.css';
import midecodes from '../../Assets/midecodes.jpg';
import cv from '../../Assets/Olufemi Olomitutu-Frontend Developer.pdf';

const Header = () => {

  useEffect(() => {
    (function() {
      var burger = document.querySelector('.burger');
      var menu = document.querySelector('.navbar-menu');
      burger.addEventListener('click', function() {
          burger.classList.toggle('is-active');
          menu.classList.toggle('is-active');
      });
     })();
    }, [])
    return(
        <div>
             <nav class="navbar is-transparent">
  <div class="navbar-brand">
    <a class="navbar-item" href="/">
      Mide.codes/>
    </a>
    <div class="navbar-burger burger" data-target="navbarExampleTransparentExample">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>

  <div id="navbarExampleTransparentExample" class="navbar-menu">
    <div class="navbar-start">
      <a class="navbar-item" href="/">
        Blog
      </a>
      <a class="navbar-item" href="#About">
        About
      </a>
      <a class="navbar-item" href="/">
        Projects
      </a>
      <a class="navbar-item" href="/">
        Contact
      </a>
    </div>

   
  </div>
</nav>
    <header class="hero">
      <div class="section-center hero-center">
        <article class="hero-info">
          <div class="underline"></div>
          <h1>I'm Mide</h1>
          <h4>Frontend Engineer & Mobile App Dev</h4>
   
        <div class="field is-grouped">
          <p class="control">
            <a class="bd-tw-button button" href="https://github.com/Midetech">
              <span class="icon">
                <i class="fab fa-github"></i>
              </span>
              <span>
                GitHub
              </span>
            </a>
          </p>
          <p class="control">
            <a class="button is-primary" href={cv}>
              <span class="icon">
                <i class="fas fa-download"></i>
              </span>
              <span>Download CV</span>
            </a>
          </p>
        </div>

  
        
          <ul class="social-icons hero-icons">
            <li>
              <a href="https://www.twitter.com/midecodeable" class="social-icon">
                <i class="fab fa-twitter"></i>
              </a>
            </li>
            <li>
              <a href="https://www.linkedin.com/in/developermide" class="social-icon">
                <i class="fab fa-linkedin"></i>
              </a>
            </li>
            <li>
              <a href="https://www.facebook.com/mide.procode" class="social-icon">
                <i class="fab fa-facebook"></i>
              </a>
            </li>
          </ul>
        </article>
        <article class="hero-img">
          <img src={midecodes} class="hero-photo" alt="midecodes" />
        </article>
      </div>
    </header>
        </div>
      
    )
}

export default Header;
